<template>
  <tr>
    <div
      class="my-1"
      style="display: flex"
      :title="device.site_sortkey"
    >
      <v-icon
        v-if="icon"
        class="ml-0 mr-2"
        color="msr"
        medium
      >
        location_on
      </v-icon>
      <v-layout column>
        <span
          class="grey--text text--darken-3"
          style="font-size: 0.9em"
        >
          {{ device.store.name }}
        </span>
        <span
          class="grey--text text--darken-1"
          align-center
          style="font-size: 0.8em"
          :title="$t('storeAssociationMemberNumber')"
        >
          {{
            device.store.association_membernumber ||
              $t('storeAssociationMemberNumberNoneYet')
          }}
        </span>
        <div>
          <strong>
            {{ device.store.city }}
          </strong>
          <span v-if="device.store.location">{{ device.store.location }}</span>
        </div>
        <div>
          {{ device.store.address }}
        </div>
      </v-layout>
    </div>
  </tr>
</template>

<script>
export default {
  props: {
    device: {
      type: Object,
      required: true,
    },
    icon: {
      type: Boolean,
      default: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Device/DeviceSite.vue